export default class artistgrid {
   constructor(el){
      this.el = el;
      this.textlinks = $(el).find('.artist-link-text');
      this.thumbs = $(el).find('.artist-link-image');

      this.gridBlocks = $('.artists-grid--block');
      this.searchContents = $('.artist-search-content');
      this.searchContentTexts = [];

      this.init();
      this.binds();

      window.artistgrid = this;
   }

   init() {
      const par = this;

      $(par.thumbs).each(function(){
         this.h3width = $(this).find('h3').outerWidth();

         let href = this.getAttribute('href');
         this.textlink = $(par.el).find(`.artist-link-text[href="${href}"]`);
      });

      $(par.textlinks).each(function(){
         let href = this.getAttribute('href');
         this.thumb = $(par.el).find(`.artist-link-image[href="${href}"]`);
      });

      for(var i=0; i<par.searchContents.length; i++) {
         par.searchContentTexts[i] = $(par.searchContents[i]).text();
      }
   }

   binds(){
      const par = this;

      $(window).on('scroll', function(){
         if((window.innerWidth < 787)) {
            $(par.gridBlocks).each(function(){
               let rect = this.getBoundingClientRect();
               // console.log(rect.top);
               if(rect.top < window.innerHeight*.2 - rect.height*.5 && rect.bottom > window.innerHeight*.2 - rect.height*.5){
                  $(this).addClass('focus');
                  // clearTimeout(this.time);
               } else {
                  // var t = this;
                  // this.time = setTimeout(function(){
                     $(this).removeClass('focus');
                  // }, 150);
               }
            })
         }
      });

      $(par.textlinks).on('mouseenter', function(){
         if(!(window.innerWidth < 787) && !window.preventMouseOvers){
            $(par.thumbs).not(this.thumb).addClass('out');
            $(this.thumb).addClass('in');
         }
      }).on('mouseleave', function(){
         if(!(window.innerWidth < 787) && !window.preventMouseOvers){
            $(par.thumbs).removeClass('in out');
         }
      });
      
      
      $(par.thumbs).on('mouseenter', function(){
         if(!(window.innerWidth < 787) && !$(this).hasClass('search-out')){
            this.h3width = $(this).find('h3').outerWidth();
            $(par.textlinks).not(this.textlink).addClass('out');
            $(this.textlink).addClass('hover');
            $(par.el).addClass('dash-out');
         }
      }).on('mouseenter, mousemove', function(e){
         if(!(window.innerWidth < 787)){
            let X = e.offsetX;
            
            // console.log(e.pageX + this.h3width);
            
            if(e.pageX + this.h3width + 8 > window.innerWidth) {
               X -= this.h3width;
            }
            
            $(this).find('h3').addClass('in').css({
               'transform' : `translate3d(${X + 5}px, ${e.offsetY + 5}px, 0)`
            });
         }
      }).on('mouseleave', function(){
         if(!(window.innerWidth < 787)){
            $(this).find('h3').removeClass('in');
            $(this.textlink).removeClass('hover');
            $(par.textlinks).removeClass('out');
            $(par.el).removeClass('dash-out');
         }
      });


      $('.freesearch--text').on('input', function(e){
         let val = $(this).val().toLowerCase();
         console.log(val);
         window.preventMouseOvers = true;
         if(val.length > 1) {
            var foundMatches = false;
            for(var i=0; i<par.searchContentTexts.length; i++) {
               if(par.searchContentTexts[i].indexOf(val)>=0) {
                  console.log(`#${i} matches search`);
                  $(par.textlinks[i]).removeClass('search-out');
                  $(par.searchContents[i]).siblings('.artist-link-image').removeClass('search-out');
                  foundMatches = true;
               } else {
                  $(par.textlinks[i]).addClass('search-out');
                  $(par.searchContents[i]).siblings('.artist-link-image').addClass('search-out');
               }
            }
            $(par.el).addClass('dash-out');
            // if(foundMatches || val.length > 1) {
            // } else {
               // $(par.el).removeClass('dash-out');
            // }
         } else {
            $(par.textlinks).removeClass('search-out');
            $(par.el).removeClass('dash-out');
            $(par.searchContents).each(function(){
               $(this).siblings('.artist-link-image').removeClass('search-out');
            });
         }

         if(val.length==0) {
            window.preventMouseOvers = false;
         }
      });
   }
}